import React from "react"
import { Cell } from "fixed-data-table-2"

// Datum cell for the BulkSMS resource tables; renders the text's contents
const BulkSMSDatumCell = ({ datum, ...props }) => {
    const description = datum && datum.get("description")

    return <Cell {...props}>{description || "(New Message)"}</Cell>
}

export default BulkSMSDatumCell
